import { ref } from 'vue';

export default function useWebGLContext() {
  const numActive = ref(0);
  const canvases: HTMLCanvasElement[] = [];
  let done = false;

  async function getMaxWebGLContexts(): Promise<number> {
    function createCanvas() {
      const canvas = document.createElement('canvas');
      canvas.addEventListener('webglcontextlost', () => {
        done = true;
        numActive.value = canvases.length - 1;
      });
      const gl = canvas.getContext('webgl');
      if (gl) {
        canvases.push(canvas);
      } else {
        done = true;
      }
    }

    const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    async function main() {
      while (!done) {
        createCanvas();
        await wait(0); // Small delay to allow the browser to process
      }
    }

    await main();

    // Cleanup all created contexts
    canvases.forEach((canvas) => {
      const gl = canvas.getContext('webgl');
      if (gl) {
        const loseContextExtension = gl.getExtension('WEBGL_lose_context');
        if (loseContextExtension) {
          loseContextExtension.loseContext();
        }
      }
    });

    return numActive.value;
  }

  return {
    getMaxWebGLContexts,
    numActive,
  };
}

const cached = useWebGLContext();
export const useWebGLContexts = () => cached;
